import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Home from './Pages/Home'
import Gateway from './Pages/Gateway';
import HowItWorksPage from './Pages/HowItWorksPage';

function App() {
  return (

    <Router>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route exact path="/gateway" component={Gateway} />
        <Route exact path="/howitworks" component={HowItWorksPage} />
      </Switch>

    </Router>

  );
}

export default App;
